import React from 'react';
import { usePortfolio } from '../../context/PortfolioContext';
import { X, CheckCircle, ExternalLink, Github, Sparkles } from 'lucide-react';

export const ProjectDetailModal: React.FC = () => {
  const { selectedProject, setSelectedProject } = usePortfolio();

  if (!selectedProject) return null;

  return (
    <div className="modal-overlay active" onClick={() => setSelectedProject(null)}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <button
          className="modal-close-btn"
          onClick={() => setSelectedProject(null)}
          aria-label="Close modal"
        >
          <X size={20} />
        </button>

        <div className="modal-body">
          <div className="project-image-wrap" style={{ height: '300px', borderRadius: '14px', marginBottom: '1.5rem' }}>
            <img
              src={selectedProject.imageUrl}
              alt={selectedProject.title}
              className="project-image"
            />
            <span className="project-category-badge">
              {selectedProject.getCategoryLabel()}
            </span>
          </div>

          <h2 style={{ fontSize: '1.8rem', color: 'var(--card-heading)', marginBottom: '0.8rem' }}>
            {selectedProject.title}
          </h2>

          <p style={{ color: 'var(--text-muted)', lineHeight: '1.7', marginBottom: '1.8rem' }}>
            {selectedProject.fullDescription}
          </p>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2rem', marginBottom: '2rem' }}>
            <div>
              <h4 style={{ color: 'var(--accent-cyan)', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <Sparkles size={16} /> Key Technical Features
              </h4>
              <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
                {selectedProject.features.map((feat, idx) => (
                  <li key={idx} style={{ display: 'flex', alignItems: 'flex-start', gap: '0.6rem', color: 'var(--text-main)', fontSize: '0.9rem' }}>
                    <CheckCircle size={16} color="var(--accent-green)" style={{ flexShrink: 0, marginTop: '3px' }} />
                    <span>{feat}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 style={{ color: 'var(--accent-violet)', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <Sparkles size={16} /> Engineering Highlights
              </h4>
              <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
                {selectedProject.keyHighlights.map((hl, idx) => (
                  <li key={idx} style={{ display: 'flex', alignItems: 'flex-start', gap: '0.6rem', color: 'var(--text-main)', fontSize: '0.9rem' }}>
                    <CheckCircle size={16} color="var(--accent-cyan)" style={{ flexShrink: 0, marginTop: '3px' }} />
                    <span>{hl}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingTop: '1.5rem', borderTop: '1px solid var(--border-color)' }}>
            <div className="project-tags">
              {selectedProject.techStack.map((tech, idx) => (
                <span key={idx} className="tech-tag">{tech}</span>
              ))}
            </div>

            <div style={{ display: 'flex', gap: '1rem' }}>
              {selectedProject.githubUrl && (
                <a
                  href={selectedProject.githubUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-secondary"
                  style={{ padding: '0.6rem 1.2rem', fontSize: '0.85rem' }}
                >
                  <Github size={16} />
                  <span>GitHub Repo</span>
                </a>
              )}
              {selectedProject.liveDemoUrl && (
                <a
                  href={selectedProject.liveDemoUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-primary"
                  style={{ padding: '0.6rem 1.2rem', fontSize: '0.85rem' }}
                >
                  <ExternalLink size={16} />
                  <span>Live Demo</span>
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
